<template>
	<!-- @cell-dblclick="dblclick" 双击功能暂时关闭 -->
	<el-table :data="tableData" border style="width: 100%" :cell-class-name="cellClassName">
		<el-table-column v-for="(item,index) in tabList" :key="index" :prop="item.prop" align="center"
			header-align="center" :label="item.label" :width="item.width" show-overflow-tooltip>
		</el-table-column>

		<el-table-column fixed="right" align="center" header-align="center" label="动作" width="120">
			<template slot-scope="scope">
				<el-button v-if="status == 'check'" @click="handleClick(scope.row,'查看')" type="text" size="small">查看
				</el-button>
				<el-button v-if="status == ''" @click="handleClick(scope.row,'编辑')" type="text" size="small">编辑
				</el-button>
				<el-button v-if="status == ''" type="text" size="small" @click="handleClick(scope.row,'删除')">删除
				</el-button>
			</template>
		</el-table-column>
	</el-table>
</template>

<script>
	import extendComponents from '../qcteam/data'
	export default {
		data() {
			return {
				tableData: this.outTable,
				tabList: this.outTabList,
				// 存一份旧值，用于校验是否发生变化，是否修改
				oldCellValue: null
			}
		},
		props: {
			status: {
				type: String,
				default: ''
			},
			// 外部数据
			outTable: {
				type: Array,
				default: () => []
			},
			// 外部表头
			outTabList: {
				type: Array,
				default: () => []
			}
		},
		methods: {
			setTableData(data) {
				this.tableData = data
			},
			// 新增
			addTable() {
				this.tableData.push({})
			},
			handleClick(row, type) {
				if (type == '删除') {
					this.tableData.splice(row.index, 1)
				}
				this.$emit('editMore', [row.index, type])
			},
			cellClassName({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				row.index = rowIndex; // 自定义指定一个索引，下方能够用到
			},
			dblclick(row, column, cell, event) {
				// 1. 序号列单元格不允许编辑，别的列单元格可以编辑
				if (column.label == "动作") {
					this.$message({
						type: "warning",
						message: "动作列不允许编辑",
					});
					return;
				}
				// 2. 存一份旧的单元格的值
				this.oldCellValue = row[column.property];
				// 3. 然后把单元格的值，作为参数传递给实例化的input组件
				let cellValue = row[column.property];
				// 4. 实例化组件以后，带着参数，再挂载到对应位置
				new extendComponents.inputC({
					propsData: {
						// 使用propsData对象传递参数，子组件在props中可以接收到
						cellValue: cellValue, // 传递单元格的值
						saveRowData: this.saveRowData, // 传递回调函数用于保存行数据，组件中可以触发之
						cellDom: cell, // 传递这个dom元素
						row: row, // 传递双击的行的数据
						property: column.property, // 传递双击的是哪个字段
					},
				}).$mount(cell.children[0]); // 5. $mount方法，用于将某个dom挂载到某个dom上
			},
			/**
			 * 失去焦点的时候有以下操作
			 *    1. 校验新值是否等于原有值，若等于，说明用户未修改，就不发请求。若不等于就发请求，然后更新tableData数据
			 *    2. 然后使用$mount方法，挂载一个新的span标签dom在页面上，即恢复原样，而span标签也是实例化的哦
			 * */
			saveRowData(params) {
				console.log("继承的子组件传递过来的数据", params);
				// 1. 看看用户是否修改了
				if (params.cellValue == this.oldCellValue) {
					console.log("未修改数据，不用发请求");
				} else {
					params.row[params.property] = params.cellValue;
					// 这里模拟一下发了请求，得到最新表体数据以后，更新tableData
					setTimeout(() => {
						//        给那个数组的     第几项            修改为什么值
						this.$set(this.tableData, params.row.index, params.row);
						this.$emit('tableData', this.tableData)
					}, 300);
				}
				/**
				 * 方式一：使用官方推荐的$mount去挂载到某个节点上，上方也是
				 * */
				new extendComponents.spanC({
					propsData: {
						cellValue: params.cellValue,
					},
				}).$mount(params.cellDom.children[0]);
			},
		},
	}
</script>

<style>

</style>
